import { Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild, input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';

@Component({
  selector: 'stock-modify',
  standalone: false,
  templateUrl: './modify.component.html',
  styleUrl: './modify.component.scss'
})
export class StockModifyComponent implements OnInit, OnDestroy {

  @ViewChild('modifyForm', { static: true }) modifyForm: NgForm | undefined
  errorMessage!: string

  public stock: any

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<StockModifyComponent>,
    private currencyPipe: CurrencyPipe
  ) {
    console.error('StockModifyComponent -> constructor', data)
    this.stock = data
  }

  ngOnInit(): void {
    console.error('StockModifyComponent -> ngOnInit')

    //Update total
    this.modifyForm?.valueChanges?.subscribe((input:any) => {
      // console.error('StockCreateComponent -> modifyForm.valueChanges', 'amount', input['stock.amount'], 'price', input['stock.price'], 'tax', input['stock.tax'])

      if(input['stock.amount'] != undefined && input['stock.price'] != undefined && input['stock.tax'] != undefined )
        this.stock.total = ((parseInt(input['stock.amount']) * parseFloat(this.currencyPipe.transform(input['stock.price'], false))) + parseFloat(this.currencyPipe.transform(input['stock.tax'], false))).toFixed(2)
    })
  }

  ngOnDestroy(): void {
    console.warn('StockModifyComponent -> ngOnDestroy')
  }

  onSubmit(): void {
    console.error('StockModifyComponent -> onSubmit', this.modifyForm?.value)

    if (this.modifyForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Stock modified!',
          values: { 
            ...this.stock, 
            amount: this.modifyForm.value['stock.amount'].toString(), 
            price: parseFloat(this.currencyPipe.transform(this.modifyForm.value['stock.price'], false)),
            tax: parseFloat(this.currencyPipe.transform(this.modifyForm.value['stock.tax'], false)),
            total: parseFloat(this.currencyPipe.transform(this.modifyForm.value['stock.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
}
